{
  "common": {
    "other": "-- Other --",
    "customFieldExistsError": "Custom field with this name already exists",
    "uniqueKeyNotUniqueError": "This key is not unique",
    "save": "Save",
    "saving": "Saving",
    "integrate": "Integrate",
    "preview": "Preview",
    "back": "Back",
    "alert": "Alert",
    "proceed": "Proceed",
    "cancel": "Cancel",
    "delete": "Delete",
    "embed": "Embed",
    "link": "Link",
    "iframeEmbed": "Iframe Embed",
    "styles": "Styles",
    "options": "Options",
    "quickAdd": "Quick Add",
    "customFields": "Custom Fields",
    "addObjectFields": "Add Object Fields",
    "personalInfo": "Personal Info",
    "contactInfo": "Contact Info",
    "submit": "Submit",
    "address": "Address",
    "customized": "Customized",
    "layout": "Layout",
    "showLabel": "Show Label",
    "background": "Background",
    "buttonBackground": "Button Background",
    "fontColour": "Font Colour",
    "textFontColour": "Text Font Colour",
    "subTextFontColour": "Sub Text Font Colour",
    "selectThemes": "Select Themes",
    "enableIcon": "Enable Icon",
    "iconType": "Icon Type",
    "iconPlacement": "Icon Placement",
    "filled": "Filled",
    "textOnly": "Text Only",
    "border": "Border",
    "borderType": "Border Type",
    "cornerRadius": "Corner Radius",
    "width": "Width",
    "padding": "Padding",
    "top": "Top",
    "bottom": "Bottom",
    "left": "Left",
    "right": "Right",
    "center": "Center",
    "default": "Default",
    "formDefault": "Form Default",
    "shadow": "Shadow",
    "color": "Color",
    "horizontal": "Horizontal",
    "vertical": "Vertical",
    "blur": "Blur",
    "spread": "Spread",
    "fieldStyle": "Field Style",
    "fontColor": "Font Color",
    "inputTextFillColor": "Input Text Fill Color",
    "inputTextColor": "Input Text Color",
    "primaryColor": "Primary Color",
    "primaryColorTooltip": "Controls the color for hover state and active state.",
    "inputTextColorTooltip": "Controls the color of text typed in input fields.",
    "mapPrimaryColorToButtonColor": "Map Primary color to Button color",
    "label": "Label",
    "fontFamily": "Font Family",
    "size": "Size",
    "weight": "Weight",
    "placeholder": "Placeholder",
    "customCSS": "Custom CSS",
    "backgroundImage": "Background Image",
    "headerImage": "Header Image",
    "miscellaneous": "Miscellaneous",
    "agencyBranding": "Agency Branding",
    "imageUploadMessage": "Click or drag an image file to this area to upload",
    "backgroundImageTooltipMessage": "The background image is intended to cover the entire page, providing a visually appealing backdrop for the form. To view the background image, click on the Preview option.",
    "headerImageTooltipMessage": "The header image is designed to cover the entire width of the form and remains positioned at the top of the form. To view the header image, click on the Preview option.",
    "onSubmit": "On Submit",
    "facebookPixelID": "Facebook Pixel ID",
    "facebookPixelIDMessage": "Ignore this field if you plan to use this form/survey inside a funnel",
    "facebookPixelEvents": "Facebook Pixel Events",
    "onpageView": "On Page View",
    "stickyContact": "Sticky Contact",
    "stickyContactMessage": "Remembers and auto-fills contact details when the user returns on the same device and browser.",
    "fieldDescription": "Field Description",
    "fieldTitle": "Field Title",
    "queryKey": "Query Key",
    "querykeyTooltipMessage": "The query key that can be used as a URL param to populate this field",
    "required": "Required",
    "hidden": "Hidden",
    "hiddenValue": "Hidden value",
    "enableCountryPicker": "Enable Country Picker",
    "altText": "Alt Text",
    "optionImageAlt": "Option image",
    "bannerAlt": "banner",
    "avatarAlt": "Avatar Name",
    "alignment": "Alignment",
    "imageWidth": "Image Width",
    "imageHeight": "Image Height",
    "logic": "Logic",
    "pleaseInput": "Please Input",
    "editHTML": "Edit HTML",
    "textStyle": "Text Style",
    "subText": "Sub Text",
    "text": "Text",
    "buttonStyle": "Button Style",
    "fullWidth": "Full Width",
    "htmlMessage": "The Custom HTML goes here",
    "htmlEditorHeader": "CUSTOM JAVASCRIPT / HTML",
    "htmlEditorBodyMessage": "Add your code here",
    "scriptAdded": "Script Added!",
    "sourceAdded": "Source Added!",
    "yesSave": "Yes, Save",
    "cancelKeep": "Cancel, Keep",
    "done": "Done",
    "addElement": "Add Element",
    "addUrlLike": "Please include valid URLs such as",
    "doNotAddRelativePath": "Do not add relative paths like",
    "or": "or",
    "addCustomFields": "Add Custom Fields",
    "customFieldSearch": "Search by Name",
    "enterSourceValue": "Enter Source Value",
    "shortLabel": "Short Label",
    "shortLabelPlaceholder": "Type a short label",
    "labelPlaceholder": "Type a label",
    "fileUploadPlaceholder": "Upload a file",
    "imagePlaceholder": "Image",
    "fillValuesPlaceholder": "Fill values",
    "customCSSTooltip": "Custom CSS takes precedence over form styling & themes and may have an impact on the theme's styling.",
    "fontFamilyTooltip": "Builder support all type of fonts if you can't see that in the list. Please search it in dropdown",
    "useGDPRCompliantFont": "Use GDPR Compliant Font",
    "enableTimezone": "Enable Timezone",
    "inputStyle": "Input Style",
    "conditionalLogicAlertOnSubmit": "Conditional logic will take precedence over the message / redirect here",
    "conditionalLogicAlertOnShowHide": "Conditional logic will take precedence over the hidden settings here",
    "placeholderFacebookPixelIdInput": "Enter Facebook Pixel ID",
    "doNotShowMessage": "Don't show again",
    "creatingForm": "Creating your form...",
    "creatingSurvey": "Creating your survey...",
    "creatingQuiz": "Creating your quiz...",
    "errorCreatingForm": "There was an error creating your form. Please try again.",
    "errorCreatingSurvey": "There was an error creating your survey. Please try again.",
    "errorCreatingQuiz": "There was an error creating your quiz. Please try again.",
    "redirectMessage": "You will be redirected to:",
    "themes": {
      "themes": "Themes",
      "alertThemeMessage": "Switching themes will result in the loss of all the current style modifications.",
      "useTheme": "Use theme",
      "removeTheme": "Remove theme"
    },
    "box": "Box",
    "line": "Line",
    "message": "Message",
    "openUrl": "Redirect to URL",
    "borderTypeList": {
      "dotted": "Dotted",
      "dashed": "Dashed",
      "solid": "Solid",
      "none": "None"
    },
    "button": "Button",
    "emailNotification": "Email Notification",
    "emailNotificationSubheader": "Receive an email when someone fills out your form",
    "subject": "Subject",
    "emailTo": "Email (To)",
    "senderName": "Sender name",
    "senderNameWarning": "Your (sub-account name) will be added if left blank",
    "emailError": "At least one email address is required",
    "emailTooltip": "The first email address is designated for the 'To' field. Any subsequent email addresses will be included in the 'Cc' field.",
    "clear": "Clear",
    "filter": "Filter",
    "noResults": "No results",
    "search": "Search",
    "showNotificationsSettings": "Show Notifications Settings",
    "emailServicePaid": "This feature is a paid service and will incur charges based on your usage.",
    "integration": "Integration",
    "validation": {
      "fieldRequired": "Field is required",
      "maxLengthExceeded": "Maximum length exceeded ({max} characters)"
    },
    "payment": {
      "payments": "Payments",
      "connected": "Connected",
      "connect": "Connect",
      "liveModeOn": "Live mode",
      "status": "Status",
      "test": "Test",
      "live": "Live",
      "paymentFields": "Payment Fields",
      "suggestAnAmount": "Suggest an amount",
      "recurringPayments": "Recurring Payments",
      "selectCurrency": "Select Currency",
      "tagActiveBGColor": "Active Tag Color",
      "includeOtherAmount": "Include other amount",
      "footerInfo": "Footer Info",
      "paymentType": "Payment Type",
      "sellProducts": "Sell Products",
      "customAmount": "Custom Amount",
      "collectPayment": "Collect Payment",
      "generalSettings": "General fields",
      "securePayments": "*100% secure & safe payments*",
      "error": {
        "addMainProductFirst": "Add a main product first",
        "priceNotFoundForBumpProduct": "Price not found for Bump Product",
        "productAlreadyAdded": "Product already added"
      },
      "product": {
        "addProduct": "Add Product",
        "productSettings": "Product Settings",
        "selectProduct": "Select Product",
        "editThisProduct": "To edit this product",
        "clickHere": "Click here",
        "show": "Show",
        "description": "Description",
        "image": "Image",
        "layoutSettings": "Layout settings",
        "singleColumn": "Single Column",
        "twoColumn": "Two Column",
        "threeColumn": "Three Column",
        "maxProductError": "Maximum 20 products are allowed in a form",
        "productSelectPlaceholder": "Please select a product",
        "orderConfirmation": "Order Confirmation",
        "orderConfirmationWarning": "Order confirmation page will be shown once payment is successful",
        "quantity": "Quantity",
        "createProduct": "To create a product",
        "noProductsAdded": "No products added yet",
        "productsWillShowHere": "Once you add products, they'll show up right here",
        "chooseProductType": "Choose Product Type",
        "mainProduct": "Main Product"
      },
      "bumProduct": {
        "price": "Price",
        "variant": "Variant",
        "headline": "Headline",
        "otoHeadline": "OTO Headline",
        "otoText": "OTO Text",
        "enableImage": "Enable Image",
        "imageMessage": "We'll grab the default product image",
        "orUploadADifferentImage": "Or upload a different image",
        "bumpProducts": "Bump Products",
        "bumpProduct": "Bump Product",
        "enableBump": "Enable Bump",
        "orderBumpStyle": "Order Bump Style",
        "classic": "Classic",
        "modern": "Modern",
        "icon": "Icon",
        "bumpTemplate": "Select Template",
        "highlightText": "Highlight Text",
        "showPrice": "Show Price",
        "bumpPriceColor": "Bump Price",
        "bumpIconColor": "Bump Icon",
        "bumpBackgroundColor": "Bump Background",
        "highlightTextColor": "Highlight Text",
        "headlineColor": "Headline",
        "otoHeadlineColor": "OTO Headline",
        "otoTextColor": "OTO Text",
        "bumpBorderColor": "Bump Border",
        "priceRequired": "Price is required",
        "headlineRequired": "Headline is required",
        "bumpProductTooltip": "A small add-on offered during checkout to boost order value. Customers can add it with a single click.",
        "templateOne": "Template 1",
        "templateTwo": "Template 2",
        "templateThree": "Template 3",
        "animationIcon": {
          "none": "None",
          "arrow": "Arrow",
          "fire": "Fire",
          "plus": "Plus",
          "giftBox": "Gift Box",
          "timer": "Timer",
          "cracker": "Cracker",
          "snack": "Snack",
          "partyBalloon": "Party Balloon",
          "flash": "Flash",
          "money": "Money",
          "spaceShuttle": "Space Shuttle"
        }
      },
      "coupons": {
        "coupons": "Coupons",
        "enableCoupon": "Enable Coupon",
        "couponAlignment": "Coupon Alignment",
        "left": "Left",
        "right": "Right",
        "fullWidth": "Full Width",
        "tooltipMessage": "Set the position of coupon input from below types"
      }
    },
    "addressSettings": {
      "autoComplete": "Auto-Complete Address",
      "addressfields": "Address Fields",
      "placeholderSearch": "Search for an address",
      "autoCompleteTooltip": "Provides ability to search and automatically populate address.",
      "streetAddress": "Street Address",
      "autoCompleteAddressTitle": "Auto Complete Address",
      "newBadge": "New",
      "defaultLabel": "Address",
      "searchPlaceholder": "Search address",
      "mandataorySearch": {
        "title": "Mandatory to Select Address in Search Bar",
        "primaryText": "Auto-complete only for Street Address",
        "secondaryText": "When enabled, whenever a user interacts with the address field, then they must select a valid address to proceed.",
        "secondaryText1": "When Disabled then they can proceed without selecting an address in search bar."
      }
    },
    "autoResponder": "Auto Responder",
    "autoResponderSubheader": "Send an automated email to the person who submits the form (email includes a copy of the information they entered in the form)",
    "replyToEmail": "Reply-to-email",
    "open": "Open",
    "won": "Won",
    "lost": "Lost",
    "abandon": "Abandon",
    "selectAPipeline": "Select a pipeline",
    "stage": "Stage",
    "status": "Status",
    "opportunityValue": "Opportunity value",
    "createNewPipeline": "Create new pipeline",
    "editOpportunitySettings": "Edit Opportunity Settings",
    "contact": "Contact",
    "opportunity": "Opportunity",
    "business": "Company",
    "add": "Add",
    "more": "More",
    "opportunityHeading": "Where do you want your opportunity to be updated?",
    "date": {
      "dateSettings": "Date Settings",
      "dateFormat": "Date Format",
      "dateSeparator": "Date Separator",
      "dateFormatTooltipMessage": "Select a date format. D stands for day, M for months, and Y for year",
      "dateSeparatorTooltipMessage": "Select a separator which will separate day, month, and year in format selected on Date Format",
      "disablePicker": "Disable Picker"
    },
    "restoreVersion": "Restore Version",
    "versionHistory": "Version History",
    "errorMessage": "Error, Retry again",
    "version": "Version:",
    "currentVersion": "Current Version",
    "messageStyling": "Message Styling",
    "validateEmailHeader": "Validate Email",
    "validateEmailDescription": "The button will become visible once the user enters their email. This feature is designed to help you generate quality leads.",
    "verifyEmail": "Verify Email",
    "validatePhoneHeader": "Validate Phone",
    "validatePhoneDescription": "The button will become visible once the user enters their phone. This feature is designed to help you generate quality leads.",
    "verifyPhone": "Verify Phone",
    "validatePhoneWarning": "To enable SMS OTP verification, please ensure your phone number is set up in your location settings",
    "addAnotherTnc": "Add another T & C",
    "tnc1": "T & C 1",
    "tnc2": "T & C 2",
    "deleteCaps": "DELETE",
    "deleteConfirmation": "Type DELETE to confirm",
    "marginPadding": "Margin & Padding",
    "style": {
      "formLayoutType": "Form Type",
      "layoutType": "Layout Type",
      "surveyType": "Survey Type",
      "oneColumn": "One Column",
      "twoColumn": "Two Column",
      "singleLine": "Single Line",
      "fieldWidth": "Field Width",
      "labelAlignment": {
        "labelAlignment": "Label Alignment",
        "labelWidth": "Label Width"
      },
      "fieldSpacing": "Field Spacing",
      "color": "color",
      "fontColor": "Font color",
      "inputBackgroundColor": "Input Background Color",
      "inputBorder": "Input Border",
      "layout": "Layout",
      "colorsAndBackground": "Colors & Background",
      "advanceSettings": "Advanced Settings",
      "inputField": "Input Field",
      "borderWidth": "Border Width",
      "borderColor": "Border Color",
      "borderStyle": "Border Style",
      "fontSize": "Font Size",
      "fontWeight": "Font Weight",
      "labelColor": "Label Color",
      "placeholderColor": "Placeholder Color",
      "shortLabelColor": "Short Label Color"
    },
    "replyToTooltip": "Customize the default Reply-To email address by using {'{'}{'{'}contact.email{'}'}{'}'} to enable replies to the contact who submits the form.",
    "content": "Content",
    "calculations": "Calculations",
    "uploadOptions": "Upload Options",
    "opportunitySettingsWarning": "Please set up opportunity settings by clicking on the Edit Opportunity Settings button.",
    "startValue": "Start Value",
    "endValue": "End Value",
    "today": "Today",
    "thisWeek": "This week",
    "last7Days": "Last 7 days",
    "thisMonth": "This month",
    "last30Days": "Last 30 days",
    "question": "Question",
    "createContactOnPartialSubmission": "Create Contact on Partial Submission",
    "howItWorks": "How it works?",
    "createContactOnPartialSubmissionDescription": "Finish the slide and click \"Next\". A new contact will automatically created and stored.",
    "swapWarningMessageSurvey": "Editing or swapping options will impact this custom field across all places where the field is used. It can also reset conditional logic. ",
    "swapWarningMessageForm": "Editing or swapping options will impact this custom field across all places where the field is used. ",
    "migrationWarningMessage": "This functionality has been migrated to the Survey Conditional Logic.",
    "optionLabel": "Option Label",
    "calculationValue": "Calculation Value",
    "addOption": "Add Option",
    "enableCalculations": "Enable Calculations",
    "allowOtherOption": "Allow Other Option",
    "productSelectionSubtext": "Allow single or multiple product selection",
    "multi": "Multi",
    "single": "Single",
    "productSelectionHeading": "Product Selection",
    "spreadToColumns": "Spread to Columns",
    "columns": "Columns",
    "customstyle": "Style",
    "standard": "Standard",
    "bubble": "Bubble",
    "integratePopup": {
      "embedCode": "Embed Code",
      "useInFunnelOrEmbedCode": "Use in Funnel/ Embed Code",
      "iframeEmbed": "Iframe Embed",
      "funnel": {
        "funnel": "Funnel",
        "chooseStep": "Choose a step",
        "copyCodeAndOpenFunnel": "Copy Code & Open Funnel"
      },
      "share": {
        "share": "Share",
        "shareViaSocials": "Share via Socials",
        "copyLink": "Copy Link"
      },
      "email": {
        "email": "Email",
        "shareViaEmail": "Share via Email",
        "emailButton": "Email",
        "blankTemplate": "Blank Template",
        "emailMarketingTemplates": "Email Marketing Templates",
        "or": "Or",
        "chooseTemplate": "Choose from your templates",
        "continue": "Continue"
      }
    },
    "rating": {
      "icon": "Icon",
      "iconAlignment": "Icon Alignment",
      "count": "Count",
      "lowestRating": "Lowest Rating",
      "highestRating": "Highest Rating",
      "iconSelectedState": "Icon Selected State",
      "iconUnselectedState": "Icon Unselected State",
      "rating": "Rating",
      "ratingSettings": "Rating Settings",
      "calculationType": {
        "calculationType": "How to Store Rating Fields in Custom Fields",
        "calculationTypeTooltip": "When you rate something 4 out of 5 stars, it means:\n- Absolute: 4 out of 5\n- Percentage: 80\n- Fraction: 0.8",
        "absolute": "Absolute",
        "percentage": "Percentage",
        "fraction": "Fraction"
      }
    },
    "desktopMode": "Desktop Mode",
    "mobileMode": "Mobile Mode",
    "versions": "Versions",
    "advanced": "Advanced",
    "edit": "Edit",
    "settings": "Settings",
    "submissions": "Submissions",
    "undo": "Undo",
    "redo": "Redo",
    "customValues": "Custom Values",
    "pickBgFromImage": "Adds a blur to the background of your message box. If you choose a background color for message box, it appears over the blurred message box.",
    "pickBgFromImageTip": "Picks a color with high contrast for the BG Image. Note: Will not be applied if the Form background has no Image",
    "messageBackgroundBlur": "Background Blur",
    "confirmationMessage": "Confirmation Message",
    "deleteOption": "Delete Option",
    "deleteConfirmationModal": {
      "defaultDescription": "Deleting an option will impact this custom field across all places where the field is used. Are you sure you wish to delete it?",
      "validationMessage": "Please enter DELETE to confirm.",
      "validationError": "Please enter DELETE"
    },
    "disqualifyImmediately": "Disqualify Immediately",
    "disqualifyAfterSubmit": "Disqualify After Submit",
    "generalSettings": "General Settings",
    "advancedSettings": "Advanced Settings",
    "customFieldName": "Custom Field Name",
    "customFieldNameTooltip": "This field name is unique for each custom field.",
    "uniqueKey": "Unique Key",
    "uniqueKeyTooltip": "This key is unique for each custom field.",
    "selectContactAssociation": "Select the association with Contacts",
    "associations": "Associations",
    "createNewAssociation": "Create new association",
    "selectAnAssociation": "Select an association",
    "loadingAssociations": "Loading associations...",
    "unknownAssociation": "Unknown Association",
    "manyToMany": "Many to Many",
    "failedToLoadAssociations": "Failed to load associations",
    "noAssociationsFound": "No associations found",
    "keepThisField": "Keep this field",
    "association": "Association",
    "customObject": "Custom Object",
    "customObjects": "Custom Objects",
    "object": "Object",

    "editAssociation": "Edit {objectName} Association",
    "editAssociationButton": "{edit} {objectName} {association}",
    "fields": "Fields",
    "primaryFieldWarning": "{fieldName} is a primary field for {objectSingular} and is required to create or update a {objectSingular}.",
    "primaryFieldTitle": "{fieldName} is required to create or update {objectSingular} record.",
    "removeAllFields": "Remove all {objectSingular} Fields",
    "customObjectsFallback": "Custom Objects",
    "noneAssociation": "None",
    "noneAssociationDescription": "No association with contacts (no contact fields present)",
    "survey": {
      "layoutType": "Survey Type",
      "oneQuestionPerPage": "One Question at a Time",
      "allQuestionsOnePage": "Many at a Time"
    },
    "quizQuestions": "Quiz Questions",
    "choiceElements": "Choice Elements",
    "otherElements": "Other Elements",
    "listEditor": {
      "prefillValueHeader": "Prefill Value",
      "labelPlaceholder": "Label",
      "valuePlaceholder": "Value",
      "optionRequiredError": "The option field is required"
    },
    "field": "Field",
    "scoreEditor": {
      "addFieldPlaceholder": "Add Field",
      "fieldLabel": "Field",
      "numberLabel": "Number"
    },
    "fileUploadEditor": {
      "fileTypes": "File Types",
      "all": "All",
      "pdf": "PDF",
      "docxDoc": "DOCX/DOC",
      "png": "PNG",
      "gif": "GIF",
      "jpgJpeg": "JPG/JPEG",
      "xlsCsv": "XLS/CSV"
    },
    "ok": "Ok",
    "select": "Select",
    "allowMultipleFiles": "Allow Multiple Files",
    "maxFileLimit": "Max File Limit",
    "privacyPolicy": "Privacy Policy",
    "termsOfService": "Terms of Service"
  },
  "fields": {
    "quizQuestions": {
      "singleChoice": "Single Choice",
      "multipleChoice": "Multiple Choice",
      "yesNo": "Yes / No",
      "shortAnswer": "Short Answer",
      "longAnswer": "Long Answer",
      "number": "Number",
      "singleDropdown": "Single Dropdown",
      "multiDropdown": "Multi Dropdown"
    },
    "personal": {
      "fullName": "Full Name",
      "firstName": "First Name",
      "lastName": "Last Name",
      "dateOfBirth": "Date of birth",
      "phone": "Phone",
      "email": "Email"
    },
    "submit": {
      "button": "Button"
    },
    "integration": {
      "sellProducts": "Sell Products",
      "collectPayment": "Collect Payment"
    },
    "address": {
      "address": "Address",
      "streetAddress": "Street Address",
      "city": "City",
      "state": "State",
      "country": "Country",
      "postalCode": "Postal Code",
      "organization": "Organization",
      "website": "Website",
      "websitePlaceholder": "Web URL goes here"
    },
    "text": {
      "singleLine": "Single Line",
      "multiLine": "Multi Line",
      "textBoxList": "Text Box List"
    },
    "choiceElements": {
      "singleDropdown": "Single Dropdown",
      "multiDropdown": "Multi Dropdown",
      "checkbox": "Checkbox",
      "radio": "Radio"
    },
    "customized": {
      "text": "Click to edit this text",
      "html": "Html",
      "htmlPlaceholder": "The Custom HTML goes here",
      "captcha": "Captcha",
      "source": "Source",
      "termsAndConditions": "T & C",
      "termsAndConditionsPlaceholder": "I agree to terms & conditions provided by the company. By providing my phone number, I agree to receive text messages from the business.",
      "score": "Score"
    },
    "other": {
      "image": "Image",
      "fileUpload": "File Upload",
      "monetary": "Monetary",
      "number": "Number",
      "datePicker": "Date Picker",
      "signature": "Signature"
    },
    "customstyle": "Style",
    "standard": "Standard",
    "bubble": "Bubble"
  },
  "survey": {
    "typeOfBuilder": "Survey",
    "survyeStyle": "Survey Style",
    "surveyName": "Survey Name",
    "surveyElement": "Survey Element",
    "addSurveyElement": "Add Survey Element",
    "cloneSlide": "Clone Slide",
    "unsavedAlertMessage": "The survey has unsaved work. Are you sure you want to leave and discard all unsaved work?",
    "thirdPartyScriptAlertMessage": "Third-party scripts inside the HTML block can provide powerful functionality, but they also bring risks to privacy, security, performance and page behavior. Therefore, we recommend that you to review the contents of this script before saving it to the survey.",
    "integrateHeader": "Integrate Survey",
    "integrateSubHeader": "Use the following options to integrate your custom survey into your website",
    "integrateCopyLinkMessage": "Copy the link below and easily share it anywhere you wish.",
    "onSurveySubmission": "On Survey Submission",
    "surveySettings": "Survey Settings",
    "oneQuestionAtTime": "One question at a time",
    "backButton": "Back Button",
    "backButtonTooltipMessage": "Back button will help users to move to the previous slide",
    "disableAutoNavigation": "Disable Auto Navigation",
    "disableAutoNavigationTooltipMessage": "Automatically navigates to the next slide after a user responds.",
    "autoNavigation": "Auto Navigation",
    "autoNavigationTooltipMessage": "Automatically navigates to the next slide after a user responds.",
    "progressBar": "Progress Bar",
    "progressBarTooltipMessage": "Turning this off will remove the Progress Bar from the survey",
    "disableAnimation": "Disable Animation",
    "disableAnimationTooltipMessage": "Turning this on will disable the slide transition animation",
    "scrollToTop": "Scroll to Top",
    "scrollToTopTooltipMessage": "If turned on, the survey will scroll to top on the next slide",
    "footerHTML": "Footer HTML",
    "footerHTMLMessage": "You can write custom CSS (using style tag) and HTML inside the same box",
    "editFooter": "Edit Footer",
    "disqualifySettings": "Disqualify Settings",
    "disqualifyImmediately": "Disqualify Immediately",
    "disqualifyAfterSubmit": "Disqualify After Submit",
    "disqualifyImmediatelyLabel": "Immediately",
    "disqualifyAfterSubmitLabel": "After Submit",
    "slideConflictAlertMessage": "This slide contains multiple questions that have a logic set to them. This can cause some unintended behavior",
    "addSlide": "Add Slide",
    "settings": "Settings",
    "delete": "Delete",
    "slideDeleteAlertMessage": "Are you sure you want to delete this slide?",
    "slideDeleteBetweenAlertMessage": "This will rearrange the other slides, are you sure you want to delete this slide?",
    "slideLabel": "Slide {n}",
    "slideName": "Slide Name",
    "slidePosition": "Slide Position",
    "jumpTo": "Jump To",
    "jumpToSubText": "Jump to a specific slide",
    "enableTimezoneSurvey": "Activating this option will capture the time zone information of the individual submitting the survey",
    "footer": {
      "footer": "Footer",
      "enableNewFooter": "Enable New Footer",
      "stickToSurvey": " Stick to Survey",
      "backgroundFill": "Background Fill",
      "footerHeight": "Footer Height",
      "enableProgressBar": "Enable Progress Bar",
      "buttons": "Buttons",
      "button": "Button",
      "buttonType": "Button Type",
      "fillNext": "Fill (next)",
      "fillPrevious": "Fill (previous)",
      "fillSubmit": "Fill (Submit)",
      "textColor": "Button Text",
      "position": "Position",
      "previousText": "Previous (text)",
      "nextText": "Next (text)",
      "submitText": "Submit (text)",
      "fillComplete": "Fill Complete",
      "fillInactive": "Fill Inactive",
      "footerType": "Footer Type",
      "stickToCard": "Stick to card",
      "stickToPage": "Stick to page",
      "stepTextColor": "Step Text Colour",
      "progressBarFill": "Progress bar Fill",
      "progressBarInactive": "Progress bar Inactive",
      "arrowFill": "Arrow Fill",
      "submitColorMobile": "Submit (Color)",
      "arrowFillColor": "Arrow Fill Color"
    },
    "surveyNotfication": "Survey notification",
    "style": {
      "surveyPadding": "Survey Padding"
    },
    "integratePopup": {
      "shareOrEmbed": "Embed or Share Survey",
      "share": {
        "openFormLink": "Open Survey Link"
      },
      "email": {
        "emailSubheader": "Create a blank email and embed your survey, or pick a template and embed it instantly."
      }
    },
    "autoResponderSubheader": "Send an automated email to the person who submits the survey (email includes a copy of the information they entered in the survey)",
    "switchToOneQuestionAtTimeOn": "Enabling 'One Question at a Time' disrupts your existing conditional logic",
    "switchToOneQuestionAtTimeOff": "Disabling 'One Question at a Time' impacts your conditional logic setup",
    "switchToOneQuestionAtTimeOnWarning": "Some conditions will no longer function as expected when questions are shown one at a time.",
    "switchToOneQuestionAtTimeOffWarning": " Some conditions designed for single-question flow will stop working as intended.",
    "createContactOnPartialSubmissionSubText": "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Survey."
  },
  "form": {
    "typeOfBuilder": "Form",
    "formStyle": "Form Style",
    "formElement": "Form Element",
    "addFormElement": "Add Form Element",
    "addConditionalLogic": "Add Conditional Logic",
    "openConditionalLogic": "Open Conditional Logic",
    "inlineForm": "Inline Form",
    "formName": "Form Name",
    "fullScreenMode": "Full Screen Mode",
    "fullScreenModetooltip": "Switching it on will cause the form to expand across the entire width of its container, stretching to the edge of the embedding area while adhering to the form's width.",
    "enableTimezoneForm": "Activating this option will capture the time zone information of the individual submitting the form",
    "formSettings": "Form Settings",
    "unsavedAlertMessage": "The form has unsaved work. Are you sure you want to leave and discard all unsaved work?",
    "thirdPartyScriptAlertMessage": "Third-party scripts inside the HTML block can provide powerful functionality, but they also bring risks to privacy, security, performance and page behavior. Therefore, we recommend that you to review the contents of this script before saving it to the form.",
    "onFormSubmission": "On Form Submission",
    "integrateForm": "Integrate Form",
    "embedlayoutType": "Embed Layout Type",
    "embedlayoutTypeSubMessage": "Select a layout to embed in a funnel or an external website",
    "triggerType": "Trigger type",
    "showOnScrolling": "Show on scrolling",
    "showAfter": "Show after",
    "seconds": "seconds",
    "alwaysShow": "Always show",
    "activationOptions": "Activation options",
    "activateOn": "Activate on",
    "visit": "visit",
    "alwaysActivated": "Always activated",
    "deactivationOptions": "Deactivation options",
    "deactivateAfterShowing": "Deactivate after showing",
    "times": "times",
    "deactiveOnceLeadCollected": "Deactivate once lead is collected",
    "neverDeactivate": "Never deactivate",
    "copyEmbedCode": "Copy embed code",
    "copyFormLink": "Copy form link",
    "openFormLink": "Open form link",
    "inline": "Inline",
    "inlineDescription": "An inline form appears along with the content of the page as a native element. It does not overlay and cannot be closed or minimized.",
    "inlineHoverDescription": "An inline form appears along with the content of the page as a native element. It does not overlay and cannot be closed or minimized.",
    "popup": "Popup",
    "popupDescription": "A pop-up shows form as an overlay inside a light-box. It cannot be minimized but closed.",
    "popupHoverDescription": "A pop-up shows form as an overlay inside a light-box. It cannot be minimized but closed.",
    "politeSlideIn": "Polite slide-in",
    "politeSlideInDescription": "A polite slide-in appears on the bottom side of screen and disappears once closed",
    "politeSlideInHoverDescription": "Appears on the bottom side of screen and disappears once closed",
    "stickySidebar": "Sticky sidebar",
    "stickySidebarDescription": "A Sticky sidebar will appear on the side of the screen and can be minimized to a tab that sticks to the side of the window",
    "stickySidebarHoverDescription": "Appear on the side of the screen and can be minimized to a tab that sticks to the side of the window",
    "allowMinimize": "Allow minimize",
    "conditonalLogic": {
      "conditions": "Conditions",
      "noExistingCondition": "No existing conditions yet",
      "freeRoamMessage": "You're free to roam without the rules - at least for now",
      "addNewCondition": "Add New Condition",
      "redirectToUrl": "Redirect to URL",
      "displayCustomMessage": "Display custom message",
      "disqualifyLead": "Disqualify lead",
      "showHideFields": "Show/Hide Fields",
      "jumpTo": "Jump To",
      "redirectToUrlSubText": "Redirect users post-submission",
      "displayCustomMessageSubText": "Show messages based on user inputs",
      "disqualifyLeadSubText": "Filter out entries under specific conditions",
      "showHideFieldsSubText": "Adjust field visibility dynamically",
      "openBelowUrl": "Open below URL",
      "showCustomMessage": "Show custom message",
      "alertConditionDelete": "Are you sure you want to delete this condition?",
      "deleteCondition": "Delete Condition",
      "conditionExecutedMessage": "Conditions will be executed from top-down order.",
      "allOperationOptions": {
        "isEqualTo": "Is Equal To",
        "isNotEqualTo": "Is Not Equal To",
        "contains": "Contains",
        "doesNotContain": "Does Not Contain",
        "startsWith": "Starts With",
        "endsWith": "Ends With",
        "isEmpty": "Is Empty",
        "isFilled": "Is Filled",
        "before": "Before",
        "after": "After",
        "greaterThan": "Greater Than",
        "lessThan": "Less Than",
        "between": "Between",
        "isChecked": "Is Checked",
        "isNotChecked": "Is Not Checked"
      },
      "logic": {
        "if": "If",
        "then": "Then",
        "and": "And",
        "or": "Or"
      },
      "phoneAlertMessage": "To search for phone numbers with a country code, you need to explicitly include the '+' symbol in your search query.",
      "deleteAlertMessage": "Are you sure you want to delete this field? The condition associated with this field will also be removed.",
      "deleteField": "Delete Field",
      "jumpToDescription": "Jump to a specific slide when conditions are met",
      "cycleError": "Cannot Save. Cycle detected between {a} and {b}",
      "jumpToSlide": "Jump To Slide",
      "submitSurvey": "Submit Survey",
      "pageTitle": "P{index} - {title}",
      "selectSlideToJumpTo": "Select slide to jump from",
      "selectedSlide": "Selected slide",
      "typeValueHere": "Please Type a value here",
      "field": "Field",
      "slide": "Slide",
      "selectFieldOrSlide": "Select Field or Slide",
      "selectFieldState": "Select Field State",
      "selectField": "Select field",
      "selectOption": "Select Option",
      "jumpToTarget": "Jump To",
      "jumpToQuestion": "Jump To Question",
      "chooseQuestion": "Choose Question",
      "includeStart": "Include start",
      "includeEnd": "Include end",
      "includeValue": "Include {value}"
    },
    "minimizedTitlePlaceholder": "Minimized title",
    "dragYourElementFromLeft": "Drag your elements here from the left",
    "formNotification": "Form notification",
    "style": {
      "formPadding": "Form Padding"
    },
    "integratePopup": {
      "shareOrEmbed": "Embed or Share Form",
      "share": {
        "openFormLink": "Open Form Link"
      },
      "email": {
        "emailSubheader": "Create a blank email and embed your form, or pick a template and embed it instantly."
      }
    },
    "choosePosition": "Choose Position"
  },
  "quiz": {
    "quizElement": "Quiz Element",
    "quizNotification": "Quiz notification",
    "viewAndCustomise": "View And Customise",
    "categoryAndScore": "Category and Score",
    "provideFeedback": "Provide feedback",
    "addQuizElement": "Add Quiz Element",
    "typeOfBuilder": "Quiz",
    "addQuestions": "Add Questions",
    "dragAndDropQuestion": "Drag and drop a Question Element here.",
    "addNewPage": "Add New Page",
    "editTemplate": "Edit Template",
    "editResultPage": "Edit Result Page",
    "clonePage": "Clone Page",
    "category": {
      "category": "Category",
      "watchVideo": "Watch this video to learn more about How Category Affects Results Page!",
      "useCategoryWhen": "Use Categories When",
      "manageCategories": "Manage Categories",
      "howItWorks": "How Does This Work 🤔",
      "howItWorks2": "How Does This Work",
      "addCategoryMessage": "Add a new category",
      "assignCategoryMessage": "Assign a category to each option",
      "editResultsMessage": "Show category score in result page",
      "addCategory": "Add Category",
      "deleteCategoryAlertMessage": "Deleting a category will result into rest of that category in all the options",
      "editOrAddNewCategories": "You can edit or add new categories",
      "toEvaluateTheResponder": "To evaluate the responder based on several factors",
      "showMultipleCategoryScore": "Show multiple category score in result page",
      "displayVaryingContent": "Display varying content on the results page depending on the category score tier",
      "theOptionFieldIsRequired": "The option field is required",
      "addManage": "Add / Manage"
    },
    "quizSettings": "Quiz Settings",
    "onQuizSubmission": "On Quiz Submission",
    "settings": "Settings",
    "deletePage": "Delete Page",
    "quizResult": {
      "resultTemplate": "Result Template",
      "quizResultAlertMessage": "The chosen result page will be shown once the quiz is completed",
      "overallScoreLabel": "Overall score"
    },
    "autoResponderSubheader": "Send an automated email to the person who submits the quiz (email includes a copy of the information they entered in the quiz)",
    "integrateHeader": "Integrate Quiz",
    "integrateSubHeader": "Use the following options to integrate your custom quiz into your website",
    "integrateCopyLinkMessage": "Copy the link below and easily share it anywhere you wish.",
    "pageLabel": "Page {n}",
    "pageName": "Page Name",
    "pagePosition": "Page Position",
    "createContactOnPartialSubmissionSubText": "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Quiz.",
    "integratePopup": {
      "shareOrEmbed": "Embed or Share Quiz",
      "share": {
        "openFormLink": "Open Quiz Link"
      },
      "email": {
        "emailSubheader": "Create a blank email and embed your quiz, or pick a template and embed it instantly."
      }
    }
  }
}
